import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'

/**
 * Page header pagination.
 *
 * **Inputs**
 * - {@link AtnDsPageHeaderPaginationComponent.currentPage|currentPage}
 * - {@link AtnDsPageHeaderPaginationComponent.totalPages|totalPages}
 *
 * **Outputs**
 * - {@link AtnDsPageHeaderPaginationComponent.increment|increment}
 * - {@link AtnDsPageHeaderPaginationComponent.decrement|decrement}
 *
 * @example
 * ```html
 * <atn-ds-page-header-pagination
 *   [currentPage]="1"
 *   [totalPages]="10"
 *   (increment)="handleIncrement()"
 *   (decrement)="handleDecrement()"
 * ></atn-ds-page-header-pagination>
 * ```
 */
@ngCore.Component({
  changeDetection: ngCore.ChangeDetectionStrategy.OnPush,
  imports: [ngCommon.NgClass],
  selector: 'atn-ds-page-header-pagination',
  standalone: true,
  styleUrls: ['./page-header-pagination.component.scss'],
  templateUrl: './page-header-pagination.component.html',
})
export class AtnDsPageHeaderPaginationComponent {
  public readonly currentPageSg = ngCore.signal(1)
  public readonly totalPagesSg = ngCore.signal(1)
  public readonly leftArrowDisabledSg = ngCore.computed(
    () => this.currentPageSg() === 1,
  )
  public readonly rightArrowDisabledSg = ngCore.computed(
    () => this.currentPageSg() === this.totalPagesSg(),
  )

  /**
   * Current page number
   */
  @ngCore.Input()
  public set currentPage(val: number) {
    this.currentPageSg.set(val)
  }

  /**
   * Total number of pages
   */
  @ngCore.Input()
  public set totalPages(val: number) {
    this.totalPagesSg.set(val)
  }

  /**
   * Event emitted when the current page is incremented.
   */
  @ngCore.Output()
  public readonly increment = new ngCore.EventEmitter<void>()

  /**
   * Event emitted when the current page is decremented.
   */
  @ngCore.Output()
  public readonly decrement = new ngCore.EventEmitter<void>()

  public onPreviousHandler(): void {
    if (!this.leftArrowDisabledSg()) {
      this.currentPageSg.set(this.currentPageSg() - 1)
      this.decrement.emit()
    }
  }

  public onNextPageHandler(): void {
    if (!this.rightArrowDisabledSg()) {
      this.currentPageSg.set(this.currentPageSg() + 1)
      this.increment.emit()
    }
  }
}
